module.exports = __webpack_public_path__ + "static/img/p7.bd85004.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/p7.png
// module id = pGBr
// module chunks = 1